// Initialize dataLayer if it doesn't exist
window.dataLayer = window.dataLayer || [];

// Track page view
export const trackPageView = (page) => {
    window.dataLayer.push({
        event: 'page_view',
        page: page
    });
};

// Track popup open
export const trackPopupOpen = (popupName) => {
    window.dataLayer.push({
        event: 'popup_open',
        popup_name: popupName
    });
};

// Track popup close
export const trackPopupClose = (popupName) => {
    window.dataLayer.push({
        event: 'popup_close',
        popup_name: popupName
    });
};

// Track form submission
export const trackFormSubmit = (formName, formData) => {
    window.dataLayer.push({
        event: 'form_submit',
        form_name: formName,
        form_data: formData
    });
};

// Track button click
export const trackButtonClick = (buttonName, buttonData = {}) => {
    window.dataLayer.push({
        event: 'button_click',
        button_name: buttonName,
        ...buttonData
    });
};

// Track custom event
export const trackCustomEvent = (eventName, eventData = {}) => {
    window.dataLayer.push({
        event: eventName,
        ...eventData
    });
}; 